import script from "./notificationBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./notificationBox.vue?vue&type=script&setup=true&lang=ts"

import "./notificationBox.vue?vue&type=style&index=0&id=101ac92e&scoped=true&lang=css"
import "./notificationBox.vue?vue&type=style&index=1&id=101ac92e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-101ac92e"]])

export default __exports__